import { AiSettingsDocument } from '~/graphql';

export const courseAiSettingCacheExchange = {
  updates: {
    Mutation: {
      createAiSettingsForCourse(result, _args, cache) {
        const courseId = _args.createAiSettingsInput.courseId;
        cache.updateQuery(
          {
            query: AiSettingsDocument,
            variables: {
              courseIdInput: { id: courseId },
            },
          },
          (data) => {
            return data;
          }
        );
      },
    },
  },
};
